<template>
  <div>
    <contract-inspections
      v-model="inspections"
      class="ml-4"
    />
    <div class="col-sm-12 button-container">
      <button
        class="btn btn-success form-button"
        :disabled="loading"
        @click.stop="submitInspections"
      >
        <span>
          {{ $t('common.save') }}
        </span>
      </button>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import ContractInspections from "./ContractInspections";
import {inject} from "vue";

export default {
    name: 'DefaultInspections',
    components: {ContractInspections},
    mixins: [restApi],
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            inspections: []
        }
    },

    methods: {
        submitInspections: function () {
            this.loading = true
            let ids = []
            this.inspections.forEach(item => ids.push(item.id))
            this.restAdd(this.defaultInspectionUrl, {inspections: ids}, this.success, this.fail)
        },

        success: function () {
            this.showAlert(this.$t('common.alert_update_success'), 'success')
            this.loading = false
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        }
    }
}
</script>
